import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

// The values of the application setting
// supplierProduct.itemProductsInSupplierProductProductsSelectList: which
// ITEM-level products the create-supplier-product dialog's Product list offers.
// Kit-level products are always offered. "Standalone" = not `inKitOnly`, i.e. a
// product that can be sold on its own.
export enum ItemProductsInSupplierProductProductsSelectListIds {
  ALL = 1,
  STANDALONE_ONLY = 2,
  NONE = 3,
}

export function getItemProductsInSupplierProductProductsSelectList(): ISelectItem[] {
  return [
    {
      id: ItemProductsInSupplierProductProductsSelectListIds.ALL,
      label: 'All Item Products',
    },
    {
      id: ItemProductsInSupplierProductProductsSelectListIds.STANDALONE_ONLY,
      label: 'Standalone Item Products Only',
    },
    {
      id: ItemProductsInSupplierProductProductsSelectListIds.NONE,
      label: 'No Item Products',
    },
  ]
}

export const getItemProductsInSupplierProductProductsSelectListItemByLabel =
  getItemByLabelFactory(getItemProductsInSupplierProductProductsSelectList)

export const getItemProductsInSupplierProductProductsSelectListItemById =
  getItemByIdFactory(getItemProductsInSupplierProductProductsSelectList)
